import React from "react";

/**
 * Double-check WhatsApp-style read receipt for customer messages.
 *  • Delivered (not yet read by the astrologer) → muted brown ticks
 *  • Read by the astrologer                     → solid blue ticks
 */
const ReadTick = ({ read }) => {
  const color = read ? "#2C9CDB" : "rgba(60, 40, 20, 0.45)";
  return (
    <span
      className="inline-flex items-center mt-0.5 mr-1"
      data-testid={read ? "msg-read-tick" : "msg-delivered-tick"}
      title={read ? "Read" : "Delivered"}
      aria-label={read ? "Read by astrologer" : "Delivered"}
    >
      <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.5 1.5L5.5 7.5L3 5" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15 1.5L9 7.5L7.5 6"  stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
};

export default ReadTick;
